// extracted by mini-css-extract-plugin
export default {"AllNavs":"NavigationItem_AllNavs__geYW6"};